/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LinkExchangeRequest
 */
export interface LinkExchangeRequest {
  /**
   * The signed link token carried in the carrier's login URL.
   * @type {string}
   * @memberof LinkExchangeRequest
   */
  token: string;
  /**
   * Who is signing in, self-asserted. The link is shared across the
   * carrier's whole team, so each browser identifies its person once;
   * the identity is baked into the session for the audit trail.
   *
   * @type {string}
   * @memberof LinkExchangeRequest
   */
  name: string;
  /**
   * The person's work email, self-asserted.
   * @type {string}
   * @memberof LinkExchangeRequest
   */
  email: string;
}

/**
 * Check if a given object implements the LinkExchangeRequest interface.
 */
export function instanceOfLinkExchangeRequest(
  value: object,
): value is LinkExchangeRequest {
  if (!("token" in value) || value["token"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function LinkExchangeRequestFromJSON(json: any): LinkExchangeRequest {
  return LinkExchangeRequestFromJSONTyped(json, false);
}

export function LinkExchangeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LinkExchangeRequest {
  if (json == null) {
    return json;
  }
  return {
    token: json["token"],
    name: json["name"],
    email: json["email"],
  };
}

export function LinkExchangeRequestToJSON(json: any): LinkExchangeRequest {
  return LinkExchangeRequestToJSONTyped(json, false);
}

export function LinkExchangeRequestToJSONTyped(
  value?: LinkExchangeRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    token: value["token"],
    name: value["name"],
    email: value["email"],
  };
}
